import api from '../Utils/api'

export const fetchUserFunctions = async () => {
  const apiResponse = await api('GET', 'dashboard/user', null)
  return apiResponse
}

export const updateStatus = async (id, status) => {
  const apiResponse = await api('PATCH', `action-items/update-status/${id}`, {
    status,
  })
  return apiResponse
}


export const getCompanyData = async () => {
  const apiResponse = await api('GET', 'dashboard/company', null)
  return apiResponse
}